import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent {
  currentRate = 0;
  maxs = 5;
  public employeeId!: string;
  public addForm!: FormGroup;
  constructor(
    private fb: FormBuilder,
    private appService: AppService,
    private dialogRef: MatDialogRef<StarRatingComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private commonService: CommonService,
    private recruiterService: RecruiterService
  ) { }
  ngOnInit(): void {
    this.addForm = this.fb.group({
      "rating": [''],
      "comment": ["", Validators.required]
    })
    if (this.dialogData) {
      this.employeeId = this.dialogData.em_i;
    }
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }
  onCancel() {
    this.dialogRef.close()
  }
  onSubmit() {
    if (this.addForm.valid == false) {
      this.addForm.markAllAsTouched();
      return;
    }
    let obj = this.addForm.value;
    obj["em_i"] = this.employeeId
    obj["id"] = this.dialogData.id
    this.recruiterService.addRating(obj).subscribe({
      next: (success: any) => {
        //this.spinner.hide()
        this.appService.showToastMessage('success', success.msg);
        this.dialogRef.close({ data_added: true })
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

}
